import { KANBAN_COLUNAS } from '../../data/kanban'

const colorMap = {
  A_FABRICAR: 'bg-slate-100  text-slate-600',
  FABRICANDO:  'bg-amber-100  text-amber-700',
  FABRICADO:   'bg-blue-100   text-blue-700',
  EXPEDICAO:   'bg-purple-100 text-purple-700',
  ROTA:        'bg-orange-100 text-orange-700',
  POS_VENDA:   'bg-green-100  text-green-700',
}

export function StatusBadge({ status }) {
  const col   = KANBAN_COLUNAS.find(c => c.id === status)
  const color = colorMap[status] || 'bg-slate-100 text-slate-600'
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color}`}>
      {col?.label || status}
    </span>
  )
}
